import Vue from 'vue';
import Vuex from 'vuex';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

import storeAccount from '@account/store'
import storeOrgmap from '@orgmap/store'
import moduleAppbase  from '@appbase/store'
import storeMail from '@mail/store'
import storeCalendar from '@calendar/store'
import storeContact from '@contact/store'
import storeWorkflow from '@workflow/store'
import storeBoard from '@board/store'
import storeGnb from '@gnb/store'
import { configureLogging } from './logging'
import { i18n } from "@appbase/util"

Vue.use(Vuex);

// initial state
const state: RootState = {
    showSidebar: false,
    currentMenu: '홈',
    loading: false,
    page: {
        current: Object.create(null),
    },
    currentPage: Object.create(null)
};

export default configureLogging(
    new Vuex.Store<RootState>({
        state,
        actions,
        getters,
        mutations,
        modules: {
            $account: storeAccount,
            $orgmap: storeOrgmap,
            $appbase: moduleAppbase,
            $mail: storeMail,
            $calendar: storeCalendar,
            $contact: storeContact,
            $workflow: storeWorkflow,
            $board: storeBoard,
            $gnb: storeGnb,
        },
    })
  )